export default __webpack_public_path__ + "static/media/five.d2682cf7.jpg";